<template>
	<Tickets userType="member" />
</template>

<script>

	export default {
		name: 'MemberTicketView',
		components: {
			'Tickets': () => import('@/components/ticket/Tickets.vue'),
		},
		data() {
			return {

			}
		}
	}
</script>
<style></style>
